<template>
  <v-footer
    
    padless
  >
    <v-card
      flat
      tile
      class="app-bar white--text text-center"
    >
      <v-card-text>
        <v-btn
        style="text-shadow: 0px 0px 20px white;"
          v-for="icon in icons"
          :key="icon"
          class="mx-4 white--text"
          icon
        >
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text style="color:#eeee; text-shadow: 0px 0px 1px black;" class="white--text ">
        The following Data might not Be accurate due to Certains Update interval.But these results are somewhat near to accurate.Kindly Contact the technoviewe team in case of data Failure and other Issues related to Design for enquires drop an email .Thank You  </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>Designed By Technoviewe-UX team</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      icons: [
        'mdi-facebook',
        'mdi-twitter',
        'mdi-linkedin',
        'mdi-instagram',
      ],
    }),
  }
</script>